export class MeasureStruct{
    description = ""
    measure = 0
}